// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-queryBuilder-components-FieldSelector-FieldSelector-module__fieldSelector--b7308 {
  width: 100%;
  min-width: 0;
}
/*# sourceMappingURL=FieldSelector.module.css.map */`, "",{"version":3,"sources":["webpack://./FieldSelector.module.less","webpack://./src/business/queryBuilder/components/FieldSelector/FieldSelector.module.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;ACCF;AACA,mDAAmD","sourcesContent":[".fieldSelector {\n  width: 100%;\n  min-width: 0;\n}\n",".fieldSelector {\n  width: 100%;\n  min-width: 0;\n}\n/*# sourceMappingURL=FieldSelector.module.css.map */"],"sourceRoot":""}]);
// Exports
export var fieldSelector = `src-business-queryBuilder-components-FieldSelector-FieldSelector-module__fieldSelector--b7308`;
export default ___CSS_LOADER_EXPORT___;
